import { render, staticRenderFns } from "./comp-background.vue?vue&type=template&id=25950669&scoped=true"
import script from "./comp-background.vue?vue&type=script&lang=js"
export * from "./comp-background.vue?vue&type=script&lang=js"
import style0 from "./comp-background.vue?vue&type=style&index=0&id=25950669&prod&lang=scss&scoped=true"
import style1 from "./comp-background.vue?vue&type=style&index=1&id=25950669&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25950669",
  null
  
)

export default component.exports